module.exports = __webpack_public_path__ + "static/media/delete_card_icon.334f0b48.JPG";